import { SxProps } from "@mui/material";

const TableContainerSXProps: SxProps = {
  width: { xs: "100%", lg: "1254px" },
  minWidth: 1100,
  m: "10px auto",
  borderCollapse: "collapse",
  overflow: "auto",
  fontSize: { xs: 16, md: 18, lg: 20 },
  "& .MuiTableCell-head": {
    border: "1px solid white",
    fontWeight: "bold",
  },
};

const TableRowSxProps: SxProps = {
  fontWeight: "bold",
  fontSize: { xs: 16, md: 18, lg: 20 },
  bgcolor: "var(--primary-500)",
  minWidth: "80px",
};

const TableButtonSxProps: SxProps = {
  minWidth: "80px",
  height: "44px",
  boxShadow: "0 2px 6px var(--shadow-sm-overlay)",
  fontSize: { lg: "23px", xs: "14px" },
  fontWeight: "regular",
  bgcolor: "var(--white)",
  borderColor: "var(--gray-250)",
};

export { TableContainerSXProps, TableRowSxProps, TableButtonSxProps };
